{
  "name": "@movilidad/passenger",
  "version": "0.1.0",
  "author": "Technit Solutions",
  "private": true,
  "description": "Shell de Passenger: identidad, tema y proyecto nativo sobre las libs de libs/app (TEC-300)",
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/common": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/platform-browser": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@capacitor/android": "^8.5.2",
    "@capacitor/app": "^8.0.0",
    "@capacitor/core": "^8.5.2",
    "@capacitor/ios": "^8.5.2",
    "@capacitor/keyboard": "^8.0.0",
    "@capacitor/network": "^8.0.0",
    "@capacitor/preferences": "^8.0.0",
    "@capacitor/splash-screen": "^8.0.0",
    "@capacitor/status-bar": "^8.0.0",
    "@ionic/angular": "^8.8.19",
    "@ionic/core": "^8.8.19",
    "@sentry/angular": "^10.47.0",
    "@tanstack/angular-query-experimental": "^5.90.22",
    "crypto-js": "^4.2.0",
    "ionicons": "^8.0.13",
    "ng-qrcode": "^21.0.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.25",
    "@angular/cli": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/compiler-cli": "^21.2.25",
    "@capacitor/cli": "^8.5.2",
    "@types/node": "^22.19.7",
    "jsdom": "^27.4.0",
    "typescript": "5.9.3",
    "vitest": "^4.0.17"
  },
  "packageManager": "pnpm@10.30.1",
  "browserslist": [
    "Chrome >=79",
    "ChromeAndroid >=79",
    "Firefox >=70",
    "Edge >=79",
    "Safari >=14.1",
    "iOS >=14.5"
  ]
}
